import api from '@/libs/axiosInstance';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface GoogleDriveOAuthRedirectResponse {
  redirectUrl: string;
}

export const useGoogleDriveRedirectUrl = () => {
  return useMutation({
    mutationFn: async (): Promise<GoogleDriveOAuthRedirectResponse> => {
      const response = await api.get('/dashboard/integrations/google-drive/redirect-url');
      return response.data.data;
    },
  });
};

export const useGoogleDriveDisconnect = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (): Promise<void> => {
      await api.post('/dashboard/integrations/google-drive/disconnect');
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['integrations'] });
      // SaveToDriveIconButton reads useDriveStatusQuery (5min staleTime).
      // Without this, the Cloud button keeps its "default" branch after
      // disconnect for up to 5min and a click ends in E_GOOGLE_DRIVE_NOT_CONNECTED.
      queryClient.invalidateQueries({ queryKey: ['drive', 'status'] });
    },
  });
};
